import React from "react";
import { useLanguage } from "../contexts/LanguageContext";

// Logo variants — assets hosted on our own domain (no external dependency)
const LOGO_DARK = "/logo-navy-silver-hd.png"; // navy + silver HD crest (for white header / light bg)
const LOGO_GOLD = "/logo-gold-200.png";       // champagne gold crest (for dark footer)
const LOGO_WHITE = "/logo-white-200.png";     // pure white crest (alt for dark bg)

export const Logo = ({ variant = "dark", showText = true, className = "" }) => {
  const { lang } = useLanguage();
  const isLight = variant === "light" || variant === "gold";
  const isGold = variant === "gold";

  const src = isGold ? LOGO_GOLD : isLight ? LOGO_WHITE : LOGO_DARK;

  return (
    <a
      href="/"
      data-testid="logo-link"
      className={`flex items-center gap-3 group ${className}`}
    >
      <span
        className="w-10 h-10 shrink-0 overflow-hidden flex items-center justify-center"
        style={{ borderRadius: 0 }}
      >
        <img
          src={src}
          alt="Richild Invest GBC"
          className="w-full h-full object-contain"
          loading="lazy"
        />
      </span>
      {showText && (
        <span className="flex flex-col leading-none">
          <span
            className={`font-serif text-base tracking-wide ${
              isGold ? "text-[#C9A961]" : isLight ? "text-white" : "text-[#0D2F4C]"
            }`}
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Richild Invest
          </span>
          <span
            className={`text-[10px] uppercase tracking-[0.25em] mt-0.5 ${
              isGold ? "text-[#C9A961]/70" : isLight ? "text-white/70" : "text-[#0D2F4C]/60"
            }`}
          >
            GBC · {lang === "fr" ? "Île Maurice" : "Mauritius"}
          </span>
        </span>
      )}
    </a>
  );
};
